import { withFormik, Form, Field } from 'formik';
import InputWrapper from '../components/base/forms.jsx';

window.InputWrapper = InputWrapper;
window.withFormik = withFormik;
window.Form = Form;
window.Field = Field;
window.Yup = require('yup');
